/* eslint-disable vue/require-v-for-key */
<template>
  <div class="steamerTicket">
    <img
      class="steamerTicket-back"
      src="../assets/freeRunning-back.png"
      alt=""
    >
    <div class="steamerTicket-content">
      <div
        class="content-left-top pointer"
        style="font-size:14px;"
      >
        <span style="color:#0080cc;"><span  @click="goto('/index')">首页</span></span> > <span style="color:#60676d;">自由行攻略</span>
      </div>
      <div class="menus">
        <div class="address-menu">
          <span class="name">目的地<i></i></span>
          <div
            class="menu"
            v-for="(item, index) in menus"
            :key="index"
            @mouseenter="menuEnter(index)"
            @mouseleave="menuLeave"
          >
            <div class="menu-content">
              <span>{{item.dname}}</span>
              <img
                v-show="item.child.length"
                :src="Triangle"
                alt=""
                class="triangle"
                :class="item.active ? 'triangle-active' : ''"
              >
              <i
                class="menu-bg-hover"
                v-show="activeIndex===index"
              ></i>
            </div>
            <div
              class="sub-menus"
              v-show="activeIndex===index"
            >
              <div
                class="sub-menu"
                v-for="(subItem, subIndex) in item.child"
                :key="subIndex"
                @click='desgetlist(subItem.id)'
              >
                {{subItem.dname}}
              </div>
            </div>
          </div>
        </div>
        <div class="time-menu" >
            <span class="name">旅行时间<i></i></span>
            <div class="menu-content">
                <div class="menu" v-for="(item, index) in timeMenus" :key="index" @click='timegetlist(item.name)'>
                    {{item.name}}
                </div>
            </div>
            <div class="choose-more" @click="shadeShow=true">
                多选
            </div>
        </div>
        <div class="time-menus-shadow" v-show="shadeShow">
            <span class="name">旅行时间<i></i></span>
            <div class="menus-shadow">
                <div class="menu-shadow" v-for="(item, index) in times" :key="index">
                    <p class="year">{{item.year}}</p>
                    <div class="sub-time" v-for="(subItem, subIndex) in item.child" :key="subIndex" @click="timeChoose(index,subIndex)">
                        <div class="sub-time-choose" :class="timeStatus[subItem.status]"></div>
                        <p :class="'p-'+timeStatus[subItem.status]">{{subItem.name}}</p>
                    </div>
                </div>
            </div>
            <div class="choose-close" @click="shadeShow=false">
                收起
            </div>
            <div class="buttons">
                <div class="commit" @click='commit'>提交</div>
                <div class="esc" @click="shadeShow=false">取消</div>
            </div>
        </div>
      </div>
      <div>
        <free :freeitems='items'></free>
      </div>
      <div class="freeRunning-main-no">没有更多...</div>
    </div>
    <div class="steamerTicket-like">
      <div class="like">
        <p>猜你喜欢</p>
        <div class='change'>
          <span @click='change'>换一批</span>
          <img src="../static/images/change.jpg" alt="">
        </div>
      </div>
      <div class="content-left-content-list">
        <Lists :lists="hotlists"></Lists>
      </div>
    </div>
  </div>
</template>

<script>
import Lists2 from '@/components/ListsContent2.vue'
import Lists from '@/components/ListsContent.vue'
import free from '@/components/free/free.vue'
import Triangle from '@/assets/img/triangle-gray.png'
import {strategylist} from '@/api/free.js'
import {formateDateNumber, toChinesNum, sliceDate} from '@/utils/index.js'
import {destinationlist} from '@/api/router.js'
import {getthemelist} from '@/api/theme.js'
import {querycontent} from '@/api/content.js'
export default {
  data () {
    return {
      Triangle,
      activeName: 'second',
      tabs: [
        // { 'name': '航期', 'index': '0' },
        { 'name': '游轮简介', 'index': '2' },
        { 'name': '甲板结构', 'index': '3' },
        { 'name': '船舱介绍', 'index': '4' },
        { 'name': '票价', 'index': '1' }
      ],
      tableHeader: [{ 'name': '三人套房', 'index': 0 }, { 'name': '三人套房', 'index': 0 }, { 'name': '三人套房', 'index': 1 }, { 'name': '主甲板套房', 'index': 2 }, { 'name': '经典套房', 'index': 3 }, { 'name': '高级套房', 'index': 4 }, { 'name': '豪华套房', 'index': 5 }, { 'name': '奢华套房', 'index': 6 }],
      activeIndex: undefined,
      menus: [
        {
          name: '极地',
          child: [
            {
              name: '南极'
            },
            {
              name: '北极'
            }
          ]
        },
        {
          name: '非洲',
          child: [
            {
              name: '尼日利亚'
            },
            {
              name: '南非'
            }
          ]
        },
        {
          name: '美洲',
          child: [
            {
              name: '迈阿密'
            },
            {
              name: '洛杉矶'
            }
          ]
        },
        {
          name: '欧洲',
          child: [
            {
              name: '法国'
            },
            {
              name: '意大利'
            }
          ]
        }
      ],
      sidelists: [
        {
          name: '北极路线1',
          introduce: '北极路线北极路线北极路线',
          money: 12345,
          num: 197,
          imgPath: require('../assets/steamerTicket-route.png'),
          active: true
        },
        {
          name: '北极路线2',
          introduce: '北极路线北极路线北极路线',
          money: 12345,
          num: 197,
          imgPath: require('../assets/steamerTicket-route.png'),
          active: false
        }
      ],
      times: [
        {
          year: '2019年',
          child: [
            {
              name: '一月',
              status: 0
            },
            {
              name: '三月',
              status: 1
            },
            {
              name: '四月',
              status: 1
            },
            {
              name: '五月',
              status: 1
            },
            {
              name: '六月',
              status: 1
            },
            {
              name: '七月',
              status: 1
            },
            {
              name: '八月',
              status: 1
            },
            {
              name: '九月',
              status: 1
            },
            {
              name: '十月',
              status: 1
            },
            {
              name: '十一月',
              status: 1
            },
            {
              name: '十二月',
              status: 1
            }
          ]
        },
        {
          year: '2020年',
          child: [
            {
              name: '一月',
              status: 1
            },
            {
              name: '二月',
              status: 1
            },
            {
              name: '三月',
              status: 1
            },
            {
              name: '四月',
              status: 1
            },
            {
              name: '五月',
              status: 1
            },
            {
              name: '六月',
              status: 1
            },
            {
              name: '七月',
              status: 1
            },
            {
              name: '八月',
              status: 1
            },
            {
              name: '九月',
              status: 1
            },
            {
              name: '十月',
              status: 2
            },
            {
              name: '十一月',
              status: 1
            },
            {
              name: '十二月',
              status: 1
            }
          ]
        }
      ],
      timeMenus: [
        {
          name: '全部'
        },
        {
          name: '一月'
        },
        {
          name: '二月'
        },
        {
          name: '三月'
        },
        {
          name: '四月'
        },
        {
          name: '五月'
        },
        {
          name: '2020年'
        }
      ],
      shadeShow: false,
      timeStatus: {
        0: 'choose-timeout',
        1: 'choose',
        2: 'choose-active'
      },
      querylist: {
        limit: 1000,
        destid: undefined,
        traveldate: undefined
      },
      items: [],
      hotlists: [],
      hotquery: {
        page: 1,
        limit: 3,
        ishot: true
      },
      hottotal: 0,
      themes: []
    }
  },
  components: {
    Lists,
    Lists2,
    free
  },
  methods: {
    goto (url) {
      this.$router.push({path: url})
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    menuEnter (index) {
      this.activeIndex = index
    },
    menuLeave (index) {
      this.activeIndex = undefined
    },
    getlist () {
      strategylist(this.querylist).then(res => {
        let date = (res.data.data.travelDateList).sort((a, b) => { return a - b })
        this.timeMenus = []
        this.times = []
        this.timeMenus.push({name: '全部'})
        let obj = {year: (new Date()).getFullYear(), child: []}
        for (let key in date) {
          this.timeMenus.push({name: toChinesNum(date[key])})
          obj.child.push({name: toChinesNum(date[key]), status: 1}) // status:0 时间过期， 1：时间有效
        }
        this.times.push(obj)
        let items = res.data.data.items
        for (let i = 0; i < items.length; i++) {
          items[i].publishedtime = formateDateNumber(items[i].publishedtime)
        }
        this.items = items
      })
    },
    commit () {
      this.querylist.traveldate = ''
      for (let i = 0; i < this.times[0].child.length; i++) {
        if (this.times[0].child[i].status === 2) {
          this.querylist.traveldate += this.times[0].child[i].name + ','
        }
      }
      this.querylist.traveldate = this.querylist.traveldate.substr(0, this.querylist.traveldate.length - 1)
      this.getlist()
      this.shadeShow = false
    },
    // 按时间筛选
    timegetlist (name) {
      this.querylist.traveldate = name
      this.getlist()
    },
    // 按目的地筛选
    desgetlist (name) {
      this.querylist.destid = name
      this.getlist()
    },
    // 选择时间
    timeChoose (index, subIndex) {
      let subTimes = this.times[index].child
      let subChild = subTimes[subIndex]

      if (!subChild.status) {
        this.$dialog({
          title: '温馨提示',
          content: '时间已过期，不可以选择'
        })
        return
      }
      subChild.status = (subChild.status === 1 ? 2 : 1)
    },
    // 获取目的地
    getdeslist () {
      destinationlist().then(({ data }) => {
        if (data.errno === 0) {
          let items = data.data.items
          let fathers = []
          items.forEach(ele => {
            if (!ele.parentid) {
              fathers.push(ele)
            }
          })

          for (let i = 0; i < fathers.length; i++) {
            fathers[i].child = []
            for (let j = 0; j < items.length; j++) {
              if (fathers[i].id === items[j].parentid) {
                fathers[i].child.push(items[j])
              }
            }
          }
          this.menus = fathers
        } else {
          this.$toast(data.errmsg, 'warn')
        }
      })
    },
    // 自由行跳转
    detail (id, img) {
      this.$router.push({
        path: '/pastReviewDetail',
        query: {
          free: true,
          id: id,
          img: img
        }
      })
    },
    getthemelist () {
      getthemelist({limit: 1000}).then(res => {
        if (res.data.errno === 0) {
          let themes = res.data.data.items
          themes.forEach(element => {
            this.themes[element.id] = element.tname
          })
          this.gethotlist()
        } else {
          this.waringword = res.data.errmsg
          this.wraingshow = true
          setTimeout(() => { this.wraingshow = false }, 1000)
        }
      })
    },
    gethotlist () {
      querycontent(this.hotquery).then(res => {
        let items = res.data.data.items
        for (let i = 0; i < items.length; i++) {
          items[i].time = `${sliceDate(items[i].travelBeginTime)}至${sliceDate(items[i].travelEndTime)}`
          items[i].classes = this.themes[items[i].themeId]
          items[i].active = false
        }
        items[0].active = true
        this.hotlists = items
        this.hottotal = res.data.data.total
      })
    },
    change () {
      if (this.hottotal <= this.hotquery.page * 3) {
        this.hotquery.page = 1
      } else {
        this.hotquery.page += 1
      }
      this.gethotlist()
    }
  },
  created () {
    this.getlist()
    this.getdeslist()
    this.getthemelist()
    this.gethotlist()
  }
}
</script>

<style lang="scss" scoped>
.menus {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 15px;
  // border: 1px solid #eff3f5;
  position: relative;
  background: #fff;
  cursor:default;
}
.pointer{
  cursor: pointer;
}
.address-menu {
  width: 100%;
  display: flex;
  align-items: center;
  .menu {
    font-size: 14px;
    color: #6a7176;
    font-weight: bold;
    line-height: 1;
    border: 1px solid #d6dde2;
    border-radius: 5px;
    margin-left: 17px;
    .menu-bg-hover {
      background: url(../assets/img/menu-bg.png) no-repeat center;
      width: 100%;
      height: 53px;
      background-size: cover;
      position: absolute;
      top: 0;
      left: -1px;
      z-index: 1020;
      transform: scale(1.08);
    }
    .menu-content {
      cursor: pointer;
      position: relative;
      display: flex;
      align-items: center;
      padding: 8px 24px;
      &:hover {
        span {
          color: #0080cc;
          transform: color 0.3s;
        }
        .triangle {
          transform: rotate(180deg);
          transition: transform 0.3s;
        }
      }
    }
    span {
      position: relative;
      z-index: 1040;
    }
  }
  .triangle {
    width: 9px;
    height: 5px;
    margin-left: 8px;
    position: relative;
    top: -1px;
    z-index: 1040;
  }
  .sub-menus {
    width: 1232px;
    position: absolute;
    top: 68px;
    left: 0px;
    z-index: 1000;
    border: 1px solid #d6dde2;
    display: flex;
    color: #6a7176;
    background: #fff;
  }
  .sub-menu {
    cursor: pointer;
    margin:8px 0;
    padding: 8px 15px;
    line-height: 1;
    // cursor:default;
    &:hover {
      background: #0080cc;
      border-radius: 5px;
      color: #fff;
    }
  }
}
.name {
  width: 64px;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #6a7176;
  font-weight: bold;
  //   margin-left: 24px;
  text-align: justify;
  display: inline-block;
  overflow: hidden;
  vertical-align: top;
  i {
    display: inline-block;
    width: 100%;
    height: 0;
  }
}
.steamerTicket {
  width: 100%;
  height: 100%;
  background: #eee;
  position: relative;
  padding-bottom:40px;
}
.steamerTicket-back {
  width: 100%;
  height: 670px;
}
.steamerTicket-content {
  width: 1280px;
  margin: 0 auto;
  background: #fff;
  transform: translateY(-196px);
  padding: 0px 24px;
  box-sizing: border-box;
  //   height:500px;
  //   display: flex;
}
.steamerTicket-content-left {
  flex: 1;
  padding-right: 24px;
  box-sizing: border-box;
}
.content-left-top {
  height: 58px;
  line-height: 58px;
  border-bottom: 1px solid #eee;
}
.content-left-tab {
  background: #eee;
  display: flex;
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  position: relative;
  margin-bottom: 30px;
}
.content-left-tab-item {
  flex: 0 0 100px;
  text-align: center;
  border-bottom: 2px solid #0080cc;
}
.content-left-tab-btn {
  height: 50px;
  line-height: 50px;
  padding: 0 24px;
  font-size: 16px;
  background: #ff6600;
  color: #fff;
  position: absolute;
  right: 0;
  bottom: 0;
}
.content-left-content {
  margin-bottom: 28px;
}
.content-left-content-title {
  width: 136px;
  height: 42px;
  margin-bottom: 20px;
}
.content-left-content-more {
  color: #c0c6c9;
  font-size: 14px;
  position: absolute;
  right: 0;
  top: -30px;
}
.content-left-content-list {
  display: flex;
  justify-content: space-between;
  position: relative;
}
.content-item {
  flex: 0 0 32%;
  /* height:100px; */
  /* margin-right:10px; */
  /* margin-bottom:10px; */
  border: 1px solid #eee;
  position: relative;
}
.content-item-img {
  width: 100%;
  height: 196px;
}
.content-item-word {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
}
.content-item-tag {
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 10px;
  padding-top: 0px;
}
.content-item-tag-item {
  padding: 5px;
  border: 1px solid #039aff;
  color: #039aff;
  margin-right: 10px;
  margin-bottom: 5px;
  font-size: 12px;
  font-style: oblique;
}
.content-item-feel {
  position: absolute;
  left: 0;
  top: 0;
  padding: 10px 16px;
  background: black;
  opacity: 0.4;
  color: #fff;
  font-size: 12px;
}
.content-item-hot {
  background: #ffa51f;
  padding: 8px 12px;
  color: #fff;
  position: absolute;
  left: 0;
  top: 164px;
  font-size: 12px;
}
.content-left-content-table {
  border-top: 1px solid #e8e8e8;
  border-left: 1px solid #e8e8e8;
  font-size: 10px;
}
.content-left-content-table-header {
  display: flex;
  height: 46px;
  line-height: 46px;
  background: #f3f3f3;
  color: #8c8c8c;
  font-size: 14px;
}
.table-header-item {
  flex: 1;
  text-align: center;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}
.content-left-content-table-body {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 90px;
  color: #8c8c8c;
}
.table-body-item {
  flex: 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  /* height:60px; */
  height: 100%;
}
.content-left-content-introduce {
  margin-top: 8px;
  line-height: 1.5;
}

.content-left-content-last {
  height: 364px;
  width: 100%;
  background: #afb6ba;
  margin-top: 28px;
  display: flex;
  position: relative;
}
.content-left-content-last-img {
  width: 560px;
  height: 370px;
  transform: translate(10px, -17px);
  /* transform: translateY(-17px); */
}
.content-left-content-last-word {
  color: #fff;
  padding: 30px 16px 30px 26px;
}
.content-left-content-last-btn {
  display: flex;
  position: absolute;
  right: 1px;
  bottom: 1px;
}
.content-last-btn {
  width: 36px;
  height: 28px;
  line-height: 30px;
  background: #dee4e7;
  margin-left: 2px;
  text-align: center;
  color: #afb6ba;
}
.steamerTicket-content-right {
  flex: 0 0 334px;
  border-left: 1px solid #eee;
  padding: 0 24px;
  box-sizing: border-box;
}
.steamerTicket-content-right-route {
}
.content-right-route-title {
  /* height:56px;
    line-height: 56px; */
  padding-top: 20px;
  font-size: 18px;
  font-weight: bold;
}
.like{
  display:flex;
  align-items: center;
  justify-content: space-between;
}
.like p{
  font-size: 1.5rem;
  color:#3f464c;
}
.change {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.change span{
  font-size:.875rem;
  color:#7f8286;
  margin-right:.375rem;
}
.change img{
  width:.875rem;
  height:.875rem;
  display: block;
  margin-top: 2px;
}
/* .content-right-route-list{
    display:flex;
   padding:20px 0;
   border-bottom:1px solid #f4f4f4;
}
.content-right-route-list-left{
    width:140px;
    height:90px;
    margin-right:10px;
}
.content-right-route-list-left img{
    width:100%;
    height:100%;
}
.content-right-route-list-right{
    flex:1;
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    width:140px;
}
.content-right-route-list-right-second{
    font-size:16px;
    color:#9ca5ab;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-bottom:15px;
}
.content-right-route-list-right-third{
    margin-bottom:0;
    display:flex;
    align-items: center;
    justify-content: space-between;
} */
.steamerTicket-like {
  width: 1280px;
  margin: 0 auto;
  /* margin-top:24px; */
  // transform: translateY(-172px);
  margin-top:-172px;
  background: #fff;
  padding: 24px;
  box-sizing: border-box;
}
.steamerTicket-like-title {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.freeRunning-main{
    width:100%;
    display:flex;
    flex-wrap:wrap;
}
.free-main-item{
    display:flex;
    margin-bottom:20px;
    padding-bottom:20px;
    border-bottom:1px solid #eee;
}
.free-main-item-left{
    width:264px;
    height:176px;
    margin-right:20px;
    position: relative;
}
.free-main-item-left-pos{
    position: absolute;
    top:0;left:10px;
}
.free-main-item-left img:nth-child(1){
    width:100%;
    height:100%;
}
.free-main-item-right{
    display:flex;
    flex-direction: column;
    // justify-content:space-between;
    // justify-content:
    width:318px;
    padding-right:10px;
}
.free-main-item-right-one{
    font-size:16px;
    font-weight:bold;
    margin-bottom:10px;
}
.free-main-item-right-two{
    font-size: 14px;
    color:#7a7a7a;
    margin-bottom:15px;
    // transform: translateY(-25px)
}
.free-main-item-right-three{
    font-size: 14px;
    color:#7a7a7a;
    margin-bottom:10px;

}
.free-main-item-right-four{
    // align-self:flex-end;
    font-size: 14px;
    color:#7a7a7a;
    display:flex;
    align-items: center;
    justify-content: space-between;
}
.freeRunning-main-no{
    text-align: center;
    font-size:14px;
    color:#6a7176;
    font-style: oblique;
    padding-bottom:40px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.time-menu {
    width: 100%;
    margin-top: 24px;
    display: flex;
    align-items: center;
    .menu-content {
        flex: 1;
        display: flex;
        align-items: center;
    }
    .menu {
      cursor: pointer;
        margin-top: -1px;
        color: #6a7176;
        font-size: 15px;
        padding: 0 20px;
        &:hover {
            font-weight: bold;
            color: #0080cc;
        }
    }
    .choose-more {
        color: #6a7176;
        font-size: 12px;
        width: 48px;
        height: 23px;
        border: 1px solid #d6dde2;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        margin-right: 24px;
        cursor: pointer;
        &:hover {
            background: #0080cc;
            border: 1px solid #0080cc;
            color: #fff;
            transition: 0.3s all;
        }
    }
}
.time-menus-shadow {
    width: 1259px;
    box-shadow: 0px 5px 10px #9e9c9c;
    position: absolute;
    top: 65px;
    left: 10px;
    z-index: 1060;
    background: #fff;
    padding: 8px 0px 65px;
    display: flex;
    .name {
        margin-left: 13px;
    }
    .menus-shadow {
        flex: 1;
    }
    .menu-shadow {
        display: flex;
        line-height: 1;
        margin: 8px 0 18px 20px;
        .year {
            font-size: 14px;
            color: #6a7176;
            font-weight: bold;
        }
    }
    .choose-close {
        color: #6a7176;
        font-size: 12px;
        width: 48px;
        height: 23px;
        border: 1px solid #d6dde2;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        margin-right: 24px;
        cursor: pointer;
        &:hover {
            background: #0080cc;
            border: 1px solid #0080cc;
            color: #fff;
            transition: 0.3s all;
        }
    }
    .buttons {
        width: 200px;
        position: absolute;
        left: 50%;
        bottom: 30px;
        z-index: 1020;
        display: flex;
        justify-content: space-between;
        transform: translateX(-50%);
    }
    .commit, .esc {
        width: 88px;
        height: 33px;
        background: #ff7e00;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #ffffff;
        border-radius: 5px;
        cursor: pointer;
    }
    .esc {
        background: #0080cc;
    }
}
.time-menus-shadow {
    width: 1259px;
    box-shadow: 0px 5px 10px #9e9c9c;
    position: absolute;
    top: 65px;
    left: 10px;
    z-index: 1060;
    background: #fff;
    padding: 8px 0px 65px;
    display: flex;
    .name {
        margin-left: 13px;
    }
    .menus-shadow {
        flex: 1;
    }
    .menu-shadow {
        display: flex;
        line-height: 1;
        margin: 8px 0 18px 20px;
        .year {
            font-size: 14px;
            color: #6a7176;
            font-weight: bold;
        }
    }
    .choose-close {
        color: #6a7176;
        font-size: 12px;
        width: 48px;
        height: 23px;
        border: 1px solid #d6dde2;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        margin-right: 24px;
        cursor: pointer;
        &:hover {
            background: #0080cc;
            border: 1px solid #0080cc;
            color: #fff;
            transition: 0.3s all;
        }
    }
    .buttons {
        width: 200px;
        position: absolute;
        left: 50%;
        bottom: 30px;
        z-index: 1020;
        display: flex;
        justify-content: space-between;
        transform: translateX(-50%);
    }
    .commit, .esc {
        width: 88px;
        height: 33px;
        background: #ff7e00;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #ffffff;
        border-radius: 5px;
    }
    .esc {
        background: #0080cc;
    }
}
.sub-time {
            display: flex;
            margin-left: 20px;
            align-items: center;
            cursor: pointer;
            .sub-time-choose {
                width: 14px;
                height: 14px;
                border-radius: 2px;
                overflow: hidden;
            }
            .choose-timeout {
                background: #ededed;
            }
            .choose {
                background: #d6e1e8;
            }
            .choose-active {
                background: url(../assets/img/check-1.png);
                background-size: cover;
            }
            p {
                font-size: 14px;
                color: #6a7176;
                margin-left: 10px;
                line-height: 1;
            }
            .p-choose-timeout {
                color: #d6dce1;
            }
        }
  .sline{
    margin:0 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/freeRunning.vue